/**Dirección de cliente para reclamo */
export class ComplaintAddress {
    /**Resumen de dirección */
    public summary:string;
    /**Tipo de calle / vía */
    public streetType: string;
    /**Descripción de calle / vía */
    public streetDescription: string;
    /**Número de calle */
    public streetNumber: string;
    /**Tipo de edificio */
    public buildingType: string;
    /**Descripción de edificio */
    public buildingDescription: string;
    /**Tipo de vivienda */
    public houseType: string;
    /**Descripción de vivienda */
    public houseDescription: string;
    /**Número de piso de vivienda */
    public houseFloorNumber: string;
    /**Tipo de interior */
    public interiorType: string;
    /**Descripción de interior */
    public interiorDescription: string;
    /**Comite o etapa */
    public physicalGroupingType: string;
    /**Descripción de comite o etapa */
    public physicalGroupingDescription: string;
    /**Conjunto de vivienda */
    public virtualGroupingType: string;
    /**Descripción de conjunto de vivienda */
    public virtualGroupingDescription: string;
    /**Manzana */
    public block: string;
    /**Lote */
    public lot: string;
    /**Código de distrito */
    public districtCode: string;
    /**Descripción de distrito */
    public districtDescription: string;
    /**Código de provincia */
    public provinceCode: string;
    /**Descripción de provincia */
    public provinceDescription: string;
    /**Código de departamento */
    public departmentCode: string;
    /**Descripción de departamento */
    public departmentDescription: string;
    /**Región */
    public region: string;
    /**Código postal */
    public postalCode: string;
}